var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadAr = function SvgFadAr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 184c-.47 2.68-.227 4.354 1 6s4.563 2.464 8 2c3.437-.464 5.078-.958 6-4 .922-3.042 40.911-105.217 40.911-105.217.601-1.537 2.13-1.93 3.404-.886 0 0 134.305 110.087 136.602 110.103 1.194.008 3.15-.157 4.942-1.477 1.656-1.22 3.173-3.57 3.824-4.25 1.355-1.414 3.54-3.424.46-6.697C227.063 176.304 104.148 78.758 100 74c-4.148-4.758-10.631-10-16-10s-13.914 2.695-16 8c-2.086 5.305-42.53 109.32-43 112z",
    stroke: "#979797",
    fillRule: "evenodd"
  })));
};
export { SvgFadAr as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-AR.f4a1604c.svg";